import React, { lazy } from 'react';
import { CalendarIcon, ArrowRightIcon } from 'lucide-react';
export function EventsSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#ffffff'
  }} data-id="element-1679">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1680">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10" data-id="element-1681">
          <div data-id="element-1682">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1683">
              Schedule
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1684">
              This Week at FLSC
            </h2>
            <div className="section-divider" data-id="element-1685" />
          </div>
          <a href="/Calendar.html" className="inline-flex items-center gap-2 text-sm font-semibold transition-colors hover:opacity-80 self-start md:self-auto" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1686">
            View Full Calendar
            <ArrowRightIcon size={15} data-id="element-1687" />
          </a>
        </div>

        <div style={{
        width: '100%',
        minHeight: '520px',
        borderRadius: '14px',
        overflow: 'hidden',
        border: '1px solid rgba(30,61,47,0.18)',
        background: '#F8F6F0',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-1688">
          <iframe title="FLSC Calendar" src="https://calendar.google.com/calendar/embed?height=600&wkst=2&bgcolor=%23F8F6F0&ctz=America%2FNew_York&src=flsportsmansclub%40gmail.com&color=%23C8A84B&showTitle=0&showNav=0&showPrint=0&showTabs=0&showCalendars=0&showTz=0&mode=AGENDA" style={{
          border: 0,
          width: '100%',
          height: '100%',
          minHeight: '520px',
          display: 'block'
        }} width="100%" height="520" frameBorder={0} scrolling="no" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-1689" />
        </div>

        <div className="mt-5 text-center" data-id="element-1690">
          <a href="/Calendar.html" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
          backgroundColor: '#1e3d2f',
          color: '#ffffff',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1691">
            <CalendarIcon size={16} data-id="element-1692" />
            View Full Calendar
          </a>
        </div>
      </div>
    </section>;
}